<app-dashboard-container
	class="dashboard-lesregistraties"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(),permanentFilterExpressions,$event)"
	[exportTypes]="variant() === DashboardVariant.ACTUEEL ? actueelExportTypes : historieExportTypes"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/lesregistratie"
		[permanentFilterExpressions]="permanentFilterExpressions"
	>
	</app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			@if (variant() === DashboardVariant.HISTORIE) {
				<app-weergave-optie label="Interval" param="interval" [value]="interval()" [enum]="Interval"></app-weergave-optie>
			}
			<app-legenda class="cl-header-utility" [attribute]="['lr_nm_lesregistratie']"></app-legenda>
		</app-dashboard-header>
		@switch (variant()) {
			@case (DashboardVariant.ACTUEEL) {
				<app-pivot-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="groeperingService.huidigeGroeperingen()"
					[subgroups]="fixedSubgroups"
					[config]="this"
				></app-pivot-table>
			}
			@case (DashboardVariant.HISTORIE) {
				<app-linechart-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="groeperingService.huidigeGroeperingen()"
					[subgroups]="historieSubgroups()"
					[batchLevels]="1"
					[intervalLevels]="nrIntervalSubgroups()"
					[config]="this.linechartConfig"
				></app-linechart-table>
			}
		}
	</section>
</app-dashboard-container>
